@if (items(); as items) { @if (items.length) {
<div class="ui-selection-cards" [libFlexRow]="true" [libFlexRowGap]="'24px'">
	@for (item of items; track item.title) {
	<div libFlexColumn [style.width]="itemsPerWidth()">
		<lib-card [cardDesign]="'selection'" [title]="item.title" class="item" (click)="item.click()">
			<div>
				<lib-image
					[alt]="item.title"
					[imageSize]="'original'"
					[image]="item.image"
					[avatarName]="item.title"
					[isRound]="false"
					[isResponsive]="true"
				></lib-image>
			</div>
			@if (isMobileView()) {
			<div class="push-top">
				<lib-button [buttonType]="'basic'" [buttonSize]="'full'">Select</lib-button>
			</div>
			}
		</lib-card>
	</div>
	}
</div>
} }
